import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, GuardsCheckEnd, Params, Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteParamsService {
    params: Params = {};
    readonly changes = new ReplaySubject<Params>(1);

    constructor(router: Router) {
        router.events
            .pipe(filter((event): event is GuardsCheckEnd => event instanceof GuardsCheckEnd && event.shouldActivate))
            .subscribe(event => this.update(event.state.root));
    }

    private update(route: ActivatedRouteSnapshot): void {
        const params: Params = {};
        while (route) {
            Object.assign(params, route.params);
            route = route.firstChild;
        }
        this.params = params;
        this.changes.next(params);
    }
}
